import { ApplicationRef, Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-announcement',
  templateUrl: './announcement.component.html',
  styleUrls: ['./announcement.component.scss']
})
export class AnnouncementComponent implements OnInit {

  private sub: any;

  show = true;

  constructor(
    private route: ActivatedRoute,
    private ngZone: NgZone,
    private ref: ApplicationRef
  ) { }

  ngOnInit(): void {
    this.sub = this.route.params.subscribe(params => {
      console.log(params);
      if(params['id'] || params['sched']) {
        this.ngZone.run(() => {
          this.show = false;
          this.ref.tick();
        });
      } else {
        this.ngZone.run(() => {
          this.show = new Date() >= new Date('2026-08-13') && new Date() < new Date('2026-08-17');//end date not inclusive
        });
      }
    });
  }

}
